export default {
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  IS_PRODUCTION: process.env.REACT_APP_BUILD === 'Production',
  IS_STAGING: process.env.REACT_APP_BUILD === 'Staging',
  IS_DEV: process.env.REACT_APP_BUILD === 'Development',
  IS_NODE_ENV_PRODUCTION: process.env.NODE_ENV === 'production',
  ENVIRONMENT: process.env.REACT_APP_BUILD || 'Development',
  BUILD_VERSION: process.env.REACT_APP_BUILD_VERSION,
};
